<template>
  <div>
    <div class="loginContainer">
      <div class="login">
        <div class="l-left">
          <img src="./images/title.jpg" alt="" />
        </div>
        <div class="l-right">
          <el-col>
            <el-card shadow="never">
              <div class="title">经销商订货系统</div>
              <div class="h_login">
                欢迎登陆
                <span>LOGIN&nbsp;PLEASE</span>
              </div>
              <div class="inputContainer">
                <div class="input-item">
                  <label for="user"> 账户 </label>
                  <br />
                  <input
                    type="text"
                    name=""
                    id="user"
                    placeholder="请输入用户名"
                    v-model="user"
                  />
                </div>
                <div class="input-item">
                  <label for="pas"> 密码 </label>
                  <br />
                  <input
                    type="password"
                    name=""
                    id="pas"
                    placeholder="请输入密码"
                    v-model="pas"
                  />
                </div>
                <div class="input-item">
                  <label for="code"> 验证码 </label>
                  <br />
                  <div class="code">
                    <input
                      type="text"
                      name=""
                      id="code"
                      placeholder="请输入验证码"
                      v-model="code"
                    />
                    <canvas id="canvas" ref="canvas" @click="canvasFlush"></canvas>
                  </div>
                </div>
                <div class="btn">
                  <button @click="login">立即登录</button>
                </div>
              </div>
            </el-card>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Login } from "@/api";
export default {
  data() {
    return {
      user: "",
      pas: "",
      code: "",
      verifyCode:''
    };
  },
  methods: {
    canvasFlush() {
      this.code_draw();
    },
   async login() {
      const { user, pas, code, verifyCode } = this;
      
      if (!user || !pas) {
        this.$notify.error({
          title: "错误",
          message: "用户名或者密码不能为空!",
          duration: 1000,
        });
      } else if (!code) {
        this.$notify.error({
          title: "错误",
          message: "请输入验证码!",
          duration: 1000,
        });
      } else if (code.toLowerCase() !== verifyCode.toLowerCase()) {
        // 使用 verifyCode 而不是 jQuery 获取的值
        this.$notify.error({
          title: "错误",
          message: "验证码输入错误!",
          duration: 1000,
        });
        this.code_draw();
        this.code = "";
      } else {
      console.log(user,pas)
        try {
          const { data: res } = await Login({
            usercode: user,
            pwd: pas,
            token: "{06945D8F - 4605 - 4514 - A467 - D2BD9B65A797}"
          });
          let result = JSON.parse(res);
          if (result[0].code !== 200) {
            this.$notify.error({
              title: "错误",
              message: result[0].message,
              duration: 1000,
            });
          } else {
            this.$notify({
              title: "成功",
              message: result[0].message,
              type: "success",
              duration: 1000,
            });
            window.sessionStorage.setItem("token", result[0].mtoken);
            window.sessionStorage.setItem("usercode", user);
            this.$router.push("/journalism");
          }
        } catch (error) {
          this.$notify.error({
            title: "错误",
            message: "登录失败，请重试",
            duration: 1000,
          });
        }
      }
    },
    // 生成二维码
      // 生成验证码
    code_draw() {
      const canvas = this.$refs.canvas;
      if (!canvas) {
        console.error('Canvas element not found');
        return;
      }
      
      const canvas_width = 88;
      const canvas_height = 31;
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      
      const context = canvas.getContext("2d");
      
      // 清空画布
      context.clearRect(0, 0, canvas_width, canvas_height);
      
      // 设置背景色
      context.fillStyle = "#c0ccc2";
      context.fillRect(0, 0, canvas_width, canvas_height);
      
      const sCode = "A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
      const aCode = sCode.split(",");
      const aLength = aCode.length;
      
      let verifyCode = [];
      
      // 绘制文字
      for (let i = 0; i <= 3; i++) {
        const j = Math.floor(Math.random() * aLength);
        const deg = (Math.random() * 30 * Math.PI) / 180;
        const txt = aCode[j];
        verifyCode[i] = txt.toLowerCase();
        
        const x = 10 + i * 20;
        const y = 20 + Math.random() * 8;
        
        context.save();
        context.font = "bold 23px 微软雅黑, Arial, sans-serif";
        context.translate(x, y);
        context.rotate(deg);
        context.fillStyle = this.code_randomColor();
        context.fillText(txt, 0, 0);
        context.restore();
      }
      
      // 保存验证码到 data 中，而不是 DOM 属性
      this.verifyCode = verifyCode.join("");
      
      // 绘制干扰线
      for (let i = 0; i <= 5; i++) {
        context.strokeStyle = this.code_randomColor();
        context.beginPath();
        context.moveTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.lineTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.stroke();
      }
      
      // 绘制干扰点
      for (let i = 0; i <= 30; i++) {
        context.fillStyle = this.code_randomColor();
        context.beginPath();
        const x = Math.random() * canvas_width;
        const y = Math.random() * canvas_height;
        context.arc(x, y, 1, 0, 2 * Math.PI);
        context.fill();
      }
    },
    
    code_randomColor() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgb(${r},${g},${b})`;
    },
  },
  mounted() {
    this.code_draw();
  },
};
</script>
<style lang='less' scoped>
.loginContainer {
  width: 100%;
  height: 100vh;
  background-image: url(./images/bg.jpg);
  background-repeat: no-repeat;
  background-position: center;
  .login {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    .codeImgBOx {
      width: 60px;
      height: 28px;
      background: pink;
      position: absolute;
      top: 0;
      right: 0;
    }
    .l-left {
      height: 625px;
      img {
        height: 100%;
      }
    }
    .l-right {
      width: 500px;
      height: 625px;
      .el-col-24 {
        height: 100%;
      }
      .el-card {
        border: 0;
        height: 100%;
        border-bottom-left-radius: 0;
      }
      .title {
        padding-top: 60px;
        font-size: 26px;
        font-weight: 600;
        text-align: center;
      }
      .inputContainer {
        .btn {
          button {
            cursor: pointer;
            width: 130px;
            height: 40px;
            line-height: 40px;
            border-radius: 20px;
            border: 0;
            outline: none;
            background: #ed1022;
            color: #fff;
            font-size: 16px;
          }
          text-align: center;
          margin-top: 30px;
        }
        .input-item {
          margin-left: 100px;
          margin-bottom: 10px;
          .code {
            position: relative;
            canvas {
              position: absolute;
              right: 57px;
              background: #c0ccc2;
              width: 88px;
              height: 31px;
              border-bottom-right-radius: 10px;
              border-top-right-radius: 10px;
            }
          }
          label {
            color: #535353;
            margin-bottom: 3px;
            display: inline-block;
            font-weight: 600;
            font-size: 16px;
          }
          input {
            border: 0;
            outline: none;
            border: 1px solid #dcdcdc;
            height: 30px;
            border-radius: 20px;
            text-indent: 10px;
            width: 298px;
          }
        }
      }
      .h_login {
        color: #bdbdbd;
        padding: 50px 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        font-size: 20px;
        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>